// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__UAlYY","label":"styles_label__1beBf"};